import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Footer.scss";
import "./FooterMobile.scss";
import goku from "../Assets/goku.png";
import naruto from "../Assets/naruto.png";
import luffy from "../Assets/luffy.png";
import zoro from "../Assets/zoro.png";
import allRightsReserve from "../Assets/allRightsReserve.png";
import bpicard from "../Assets/Design/fbpicard.png";
import bdocard from "../Assets/Design/fbdocard.png";
import gcashcard from "../Assets/Design/fgcashcard.png";
import shopeecard from "../Assets/Design/fshopeecard.png";
import { useAppContext } from "../Components/AppProvider";

function Footer() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [manufacturers, setManufacturers] = useState([]);
  const {
    hasNewBagCount,
    setHasBagCount,
    customerId,
    setCustomerId,
    setUpdateOrderHistoryNav,
    hasWishlistCount,
    setHasWishlistCount,
  } = useAppContext(); // ✅ grab bag count
  // Fetch product categories dynamically
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/product/add-get-foreign`
        );
        const data = await res.json();
        setCategories(data.categories || []);
        setManufacturers(data.manufacturers || []);
      } catch (err) {
        console.error("Failed to fetch categories:", err);
      }
    };
    fetchCategories();
  }, []);
  const HandleProfileClick = () => {
    localStorage.setItem(
      "redirect",
      JSON.stringify({
        nav: 0,
        side: 0,
      })
    );
    setUpdateOrderHistoryNav(true);
    navigate("/customer-profile");
  };
  const handleOrdeHistory = () => {
    localStorage.setItem(
      "redirect",
      JSON.stringify({
        nav: 1,
        side: 0,
      })
    );
    setUpdateOrderHistoryNav(true);
    navigate("/customer-profile");
  };

  const HandleWishClick = () => {
    localStorage.setItem(
      "redirect",
      JSON.stringify({
        nav: 2,
        side: 0,
      })
    );
    setUpdateOrderHistoryNav(true);
    navigate("/customer-profile");
  };
  return (
    <footer className="footer">
      <div className="nav-container">
        {/* HOME */}
        <div className="guidelines-wrapper home">
          <span
            className="title"
            onClick={() => {
              navigate("/");
            }}
          >
            HOME
          </span>
          <div className="list">
            <span
              onClick={() => {
                navigate("/", {
                  state: { section: "NewArrival" },
                });
              }}
            >
              New Arrival
            </span>
            <span
              onClick={() => {
                navigate("/", {
                  state: { section: "MostPop" },
                });
              }}
            >
              Most Popular
            </span>
            <span
              onClick={() => {
                navigate("/", {
                  state: { section: "Onhand" },
                });
              }}
            >
              On Hand
            </span>
            <span
              onClick={() => {
                navigate("/", {
                  state: { section: "Preorder" },
                });
              }}
            >
              Pre Order
            </span>
            <span
              onClick={() => {
                navigate("/", {
                  state: { section: "AnimeSeries" },
                });
              }}
            >
              Anime Series
            </span>
          </div>
        </div>

        {/* PRODUCTS - dynamic */}
        <div className="guidelines-wrapper product">
          <span className="title">PRODUCTS</span>
          <div className="list">
            <Link to="/products" state={{ catId: undefined }}>
              <span>All Products</span>
            </Link>
            {categories.map((cat) => (
              <Link key={cat.PC_ID} to="/products" state={{ catId: cat.PC_ID }}>
                <span>{cat.PC_Name}</span>
              </Link>
            ))}
          </div>
        </div>

        {/* ORDER GUIDELINES */}
        <div className="guidelines-wrapper guidelines">
          <span className="title">ORDER GUIDELINES</span>
          <div className="list">
            <span
              onClick={() =>
                navigate("/guidelines", { state: { section: "preorder" } })
              }
            >
              Pre Order
            </span>
            <span
              onClick={() =>
                navigate("/guidelines", {
                  state: { section: "item-condition" },
                })
              }
            >
              Item Condition
            </span>
            <span
              onClick={() =>
                navigate("/guidelines", { state: { section: "downpayment" } })
              }
            >
              Downpayment
            </span>
            <span
              onClick={() =>
                navigate("/guidelines", {
                  state: { section: "estemated-arival" },
                })
              }
            >
              ETA
            </span>
            <span
              onClick={() =>
                navigate("/guidelines", { state: { section: "delay" } })
              }
            >
              Delays
            </span>
            <span
              onClick={() =>
                navigate("/guidelines", { state: { section: "balance" } })
              }
            >
              Balance
            </span>
            <span
              onClick={() =>
                navigate("/guidelines", { state: { section: "joy-dibbing" } })
              }
            >
              Joy Dibbing
            </span>
            <span
              onClick={() =>
                navigate("/guidelines", { state: { section: "cancellation" } })
              }
            >
              Order Cancellation
            </span>
            <span
              onClick={() =>
                navigate("/guidelines", { state: { section: "returns" } })
              }
            >
              Returns
            </span>
            <span
              onClick={() =>
                navigate("/guidelines", { state: { section: "item-claiming" } })
              }
            >
              Item Claiming
            </span>
            <span
              onClick={() =>
                navigate("/guidelines", {
                  state: { section: "delivery-shipment" },
                })
              }
            >
              Delivery
            </span>
            <span
              onClick={() =>
                navigate("/guidelines", {
                  state: { section: "mode-of-payment" },
                })
              }
            >
              Mode of Payment
            </span>
          </div>
        </div>

        {/* LEARN MORE & MY ACCOUNT */}
        <div className="learnmore-container">
          <div className="learnmore-wrapper account">
            <span className="title">MY ACCOUNT</span>
            <div className="list">
              <span onClick={HandleProfileClick}>My Profile</span>
              <span onClick={handleOrdeHistory}>Order History</span>
              <span onClick={HandleWishClick}>Wishlist</span>
            </div>
          </div>
          <div className="learnmore-wrapper learn">
            <span className="title">LEARN MORE</span>
            <div className="list">
              <span
                onClick={() => {
                  navigate("/learnmore", {
                    state: { section: "aboutus" },
                  });
                }}
              >
                About Us
              </span>
              <span
                onClick={() => {
                  navigate("/learnmore", {
                    state: { section: "contactus" },
                  });
                }}
              >
                Contact Us
              </span>
            </div>
          </div>
        </div>

        {/* PAYMENT METHODS */}
        <div className="payment-wrapper">
          <span className="title">PAYMENT METHOD</span>
          <div className="list">
            <img src={bpicard} alt="BPI" />
            <img src={bdocard} alt="BDO" />
            <img src={gcashcard} alt="GCash" />
            <img src={shopeecard} alt="Shopee Pay" />
          </div>
        </div>

        <div className="payment-wrapper">
          <span className="title">MANUFACTURER</span>
          <div className="list">
            {" "}
            {manufacturers.map((m) => (
              <img
                key={m.PM_ID}
                src={`${process.env.REACT_APP_BASE_URL}Assets/Manufacturer/${m.PM_Name}/${m.PM_Logopath}`}
                alt={m.PM_Name}
                className="manufacturer-logo"
                onClick={() =>
                  navigate("/products", { state: { manufacturerId: m.PM_ID } })
                }
              />
            ))}
          </div>
        </div>
      </div>

      {/* ANIME SILHOUETTE */}
      <div className="animeSilhouette">
        <img className="goku" src={goku} alt="Goku" />
        <img className="naruto" src={naruto} alt="Naruto" />
        <img className="luffy" src={luffy} alt="Luffy" />
        <img className="zoro" src={zoro} alt="Zoro" />
        <img
          className="allRightsReserve"
          src={allRightsReserve}
          alt="All Rights Reserved"
        />
        <hr className="dashed-line1" />
        <hr className="dashed-line2" />
        <hr className="dashed-line3" />
        <hr className="dashed-line4" />
      </div>
    </footer>
  );
}

export default Footer;
